import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import {
	LimiteGlobal,
	LimiteGlobalRetornoProduto,
} from '../../models/limite-global';
import { ModalAjusteLimiteLgComponent } from '../modal-ajuste-limite-lg/modal-ajuste-limite-lg.component';
import { ModalAjusteRealizadoLgComponent } from '../modal-ajuste-realizado-lg/modal-ajuste-realizado-lg.component';

@Component({
	selector: 'app-card-limite-credito-lg',
	templateUrl: './card-limite-credito-lg.component.html',
	styleUrls: ['./card-limite-credito-lg.component.styl'],
})
export class CardLimiteCreditoLgComponent implements OnInit {
	@Input() limiteGlobal: LimiteGlobal;
	cartaoCredito: LimiteGlobalRetornoProduto;

	constructor(public dialog: MatDialog) {}

	ngOnInit(): void {
		this.cartaoCredito = this.limiteGlobal.Produtos.find(
			(f) => f.Codigo === 'CARTÃO DE CRÉDITO'
		);
	}

	public get valorAprovado(): number {
		return this.limiteGlobal.ValorTotal;
	}

	public get valorDisponivel(): number {
		return this.cartaoCredito.ValorDisponivel;
	}

	public get canChangeValor(): boolean {
		return !!(
			this.cartaoCredito &&
			this.cartaoCredito.ValorDisponivel &&
			this.cartaoCredito.PermiteAlterarValor
		);
	}

	public openModalAjusteLimite(): void {
		const dialogRef = this.dialog.open(ModalAjusteLimiteLgComponent, {
			width: '450px',
			data: {
				limite: this.cartaoCredito.ValorUtilizado,
				max: this.cartaoCredito.ValorTotal,
				min: this.cartaoCredito.ValorUtilizado,
			},
		});

		dialogRef.afterClosed().subscribe((result) => {
			if (result) {
				this.openModalAjusteLimiteRealizado(result);
			}
		});
	}

	public openModalAjusteLimiteRealizado(valor: number): void {
		this.dialog.open(ModalAjusteRealizadoLgComponent, {
			width: '450px',
			data: valor,
		});
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/limite-global/components/card-limite-credito-lg/card-limite-credito-lg.component.ts